import cookieTool from './CookieTool';

/**
 * Gets and decodes user info from a cookie
 */
const getUserInfo = () => {
  const userInfo = cookieTool.getCookie('puheet_info');
  if (!userInfo) return { signedIn: false };

  let decodedUserInfo = decodeURIComponent(userInfo);

  if (decodedUserInfo.indexOf('j:') === 0) {
    decodedUserInfo = decodedUserInfo.substring(2);
  }
  return JSON.parse(decodedUserInfo);
};

export default {
  getUserInfo,
};
